import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Meta Pixel initialization
function AppWithPixel() {
  useEffect(() => {
    console.log('Initializing Meta Pixel...');
    // Check if fbq already exists
    if ((window as any).fbq) {
      console.log('fbq already exists, reinitializing with new pixel ID');
      (window as any).fbq('init', '752017830664443');
      (window as any).fbq('track', 'PageView');
      console.log('Meta Pixel 752017830664443 initialized');
      return;
    }
    // Create fbq function
    const fbq: any = function () {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
      } else {
        fbq.queue.push(arguments);
      }
    };
    (window as any).fbq = fbq;
    (window as any)._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    // Load the Facebook Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Wait for script to load before initializing
    script.onload = () => {
      // Initialize pixel with ID after script loads
      fbq('init', '752017830664443');
      fbq('track', 'PageView');
      console.log('Meta Pixel 752017830664443 initialized successfully');
    };
    script.onerror = () => {
      console.error('Failed to load Meta Pixel script');
    };
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  }, []);
  return <App data-id="element-306" />;
}
render(<AppWithPixel data-id="element-307" />, document.getElementById('root'));